module.exports = __webpack_public_path__ + "media/images/countryrect/gg-d905a2974b70b663317b07db0fca052c.svg";